import React from 'react';
import { Segment } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';

import PathView from '../PathView';
import DocumentTitle from '../DocumentTitle';
import withTicketQuery from '../HOC/withTicketQuery';
import TicketFormContainer from './TicketFormContainer';
import Content from '../Content';

const NewTicketForm = ({ edit, match, ...rest }) => (
  <Content fullWidth>
    <DocumentTitle title={edit ? `Ticket ${match.params.id}` : `New Ticket`} />
    <PathView paths={edit ? [
      { name: 'Tickets', path: '/tickets' },
      { name: match.params.id, path: `/ticket/${match.params.id}` },
      { name: 'Edit' }
    ] : [
        { name: 'Tickets', path: '/tickets' },
        { name: 'New' }
      ]} />
    <Segment>
      <TicketFormContainer edit={edit} {...rest} />
    </Segment>
  </Content>
);

export default withRouter(NewTicketForm);

const EditTicketForm = withTicketQuery(props => (
  <NewTicketForm edit {...props} />
));

export { EditTicketForm };



// WEBPACK FOOTER //
// ./src/component/TicketFormPage/index.js